<template>
  <div v-if="currentRoles.name === '模板管理'" class="page-index label-manage">
    <div class="toolbar-box">
      <el-button v-if="currentRoles.roles['模板管理-新增']" class="btn-left" size="mini" @click="openEditPage(null)">添加模板</el-button>
      <div style="flex:1"></div>
      <el-select v-if="userInfo.companyList.length > 0" class="search-input2" multiple collapse-tags v-model="query.companyIds" @change="seach" placeholder="请选择公司">
        <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select class="search-input" v-model="status" @change="seach">
        <el-option label="使用中" value="0"></el-option>
        <el-option label="已禁用" value="1"></el-option>
      </el-select>
      <el-input  class="search-input" size="mini" v-model="query.query" @keyup.enter.native="seach" placeholder="请输入关键字" />
    </div>
    <el-table
        ref="table"
        :data="list"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
      <el-table-column
          header-align="center"
          align="center"
          type="index"
          :index="indexMethod"
          width="50"
          label="#">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop="number"
          label="模板编号">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="模板名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="product.code"
          label="商品编号">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="product.name"
          label="商品名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="180"
          label="操作">
        <template slot-scope="scope">
          <div v-if="scope.row.editer">
            <div v-if="currentRoles.roles['模板管理-禁用']" style="display:inline-block;margin-right:10px;">
              <el-tooltip v-if="scope.row.status === 0" content="禁用" placement="top">
                <el-button size="mini" @click.stop="handleSwitch(scope.row)" title="禁用">
                  <i class="icon el-icon-disable"></i>
                </el-button>
              </el-tooltip>
              <el-tooltip v-if="scope.row.status === 1" content="启用" placement="top">
                <el-button size="mini" @click.stop="handleSwitch(scope.row)">
                  <i class="icon el-icon-enable"></i>
                </el-button>
              </el-tooltip>
            </div>
            <el-tooltip v-if="currentRoles.roles['模板管理-编辑']" content="编辑" placement="top">
              <el-button size="mini" @click.stop="openEditPage(scope.row)">
                <i class="icon el-icon-edit"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip v-if="currentRoles.roles['模板管理-删除']" content="删除" placement="top">
              <el-button size="mini" @click.stop="handleDelete(scope.row)">
                <i class="icon el-icon-delete"></i>
              </el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import { formatDate, dynamicChangeRoute } from '../../utils/common'
  import { apiLabelEdit, apiDelete, apiSwitch, apiDetail, apiLabelList, apiCopyLabel } from '../../api/label'
  import { apiList } from '../../api/product'

  export default {
    mixins: [tableMixin],
    name: 'userInfo',
    data() {
      return {
        dialogVisible: false,
        dialogVisible2: false,
        list: [],
        list2: [],
        productList: [],
        status: '0',
        pageIndex: 1,
        total: 0,
        companyId: null,
        id: '',
        currentRow: {},
        query: {
          query: '',
          companyIds: []
        },
        form: {
          name: '',
          companyId: '',
          productId: '',
          copyLabelCode: '',
          address: ''
        }
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      let mainRoutes = dynamicChangeRoute(this.$router, this.$route)
      this.$router.addRoutes([mainRoutes])
      if (this.userInfo.type === 1) {
        this.userInfo.companyList = [this.userInfo.companyList[0]]
      }
      if (this.userInfo.companyList) {
        this.query.companyIds.push(this.userInfo.companyList[0].id)
        this._getList()
      }
    },
    activated() {
      this.pageIndex = this.$route.query.pageIndex !== undefined ? this.$route.query.pageIndex : this.pageIndex
      this.query.companyIds = this.$route.query.companyIds !== undefined ? this.$route.query.companyIds : this.query.companyIds
      this.query.query = this.$route.query.query !== undefined ? this.$route.query.query : this.query.query
      this.status = this.$route.query.status !== undefined ? this.$route.query.status : this.status
      this._getList(this.pageIndex)
    },
    methods: {
      indexMethod(index) {
        return (this.pageIndex - 1) * 20 + index + 1
      },
      // 打开添加/修改页面
      openEditPage(row) {
        if (row) {
          this.$router.push({
            path: `${this.$route.path}/edit/${row.id}`,
            query: {
              status: this.status,
              query: this.query.query,
              companyIds: this.query.companyIds,
              pageIndex: this.pageIndex
            }
          })
        } else {
          this.$router.push({
            path: `${this.$route.path}/edit/0`,
            query: {
              status: this.status,
              query: this.query.query,
              companyIds: this.query.companyIds,
              pageIndex: this.pageIndex
            }
          })
        }
      },
      // 打开model
      openModel(row) {
        if (row) {
          this.dialogVisible2 = true
          this.productList.push(row.product)
          this.form.name = row.name
          this.form.productId = row.product.id
          this.form.address = row.address
          this.id = row.id
          this.currentRow = row
        } else {
          this.dialogVisible = true
          this.form = {
            name: '',
            companyId: '',
            productId: '',
            copyLabelCode: '',
            address: '',
            isEntrust: false
          }
        }
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 关闭对话框
      handleClose() {
        this.$confirm('确认关闭？').then(_ => {
          this.dialogVisible = false
          this.dialogVisible2 = false
        }).catch(_ => {})
      },
      // 搜索
      seach() {
        this.pageIndex = 1
        this._getList()
      },
      seach2() {
        this._getList2()
      },
      openPage() {
        window.open('http://dev.anschina.cn:8080/mr/mireport/designer/r.jsp?report=' + this.currentRow.number + '&ds=tagbzd1')
      },
      // 获取商品列表
      getProductList(value) {
        apiList(this.companyId, value, '', 1, 10).then(data => {
          this.productList = data.data.data
        })
      },
      // 获取列表
      _getList(pageIndex = 1) {
        if (this.query.companyIds.length === 0) return
        apiLabelList(1, this.status, this.query, pageIndex).then(data => {
          data.data.data.forEach(item => {
            let index = -1
            if (this.userInfo.companyIds) {
              index = this.userInfo.companyIds.split(',').indexOf(item.companyId + '')
            }
            if (index > -1) {
              item.editer = true
            } else {
              item.editer = false
            }
          })
          this.list = data.data.data
          this.total = data.data.total
        })
      },
      // 获取列表
      _getList2(pageIndex = 1) {
        apiLabelList(1, 0, { companyIds: [this.companyId] }, pageIndex, 9999).then(data => {
          this.list2 = data.data.data
        })
      },
      // 新增
      handleAdd() {
        let label = {
          name: this.form.name,
          companyId: this.companyId,
          productId: this.form.productId,
          address: this.form.address
        }
        apiLabelEdit(label).then(data => {
          this.$message({
            type: 'success',
            message: '新增成功'
          })
          if (this.form.copyLabelCode) { // 复用
            apiCopyLabel(this.form.copyLabelCode, data.data.number)
          }
          this.dialogVisible = false
          this._getList()
        })
      },
      // 编辑
      handleEdit() {
        let label = {
          id: this.id,
          name: this.form.name,
          productId: this.form.productId,
          address: this.form.address
        }
        apiLabelEdit(label).then(() => {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.dialogVisible2 = false
          this._getList()
        })
      },
      // 禁用/启用
      handleSwitch(row) {
        this.$confirm(`是否${row.status === 0 ? '停用' : '启用'}模板：${row.name}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiSwitch(row.id).then(() => {
            this.$message({
              type: 'success',
              message: `${row.status === 0 ? '停用' : '启用'}成功`
            })
            this._getList()
          })
        })
      },
      // 删除
      handleDelete(row) {
        this.$confirm(`是否删除模板：${row.name}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiDelete(row.id, 2).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this._getList()
          })
        })
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.label-manage
    .table-box
      border-collapse collapse
      display table
      width 100%
      td
        text-align center
        padding 5px 10px
        border 1px solid #DDD
        width calc(100% / 6)
    .switch-label
      .el-form-item__label
        text-align left
    .el-form-item__content > div
      width 100%
    .btn-left
      background #A5CE1C
      color #fff
    .el-table
      .has-gutter
        th
          background #F5F7FA
          border-right 1px solid #EBEEF5
          border-top 1px solid #ebeef5
    .toolbar-box
      display flex
      margin 10px 0
      .search-input2
        margin-right 10px
      .search-input
        width 150px
        margin-right 10px
        .el-input__inner
          height 36px
          line-height 36px
      .select-box
        width 120px
        margin-right 10px
    .upload
      .el-upload
        width 100%
        .el-upload-dragger
          width 100%
</style>
